// extracted by mini-css-extract-plugin
export default {"section-header":"oohECq","section-header__label":"xMcKzL"};